"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    sorterNedtrekksliste: function() {
        return sorterNedtrekksliste;
    },
    sorterNedtrekkslisteEtterGruppering: function() {
        return sorterNedtrekkslisteEtterGruppering;
    },
    sorterForekomster: function() {
        return sorterForekomster;
    }
});
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _transformering = require("../transformering");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var sorterListe = function(sortering, locale) {
    return function(a, b) {
        switch(sortering){
            case "alfabetisk":
                {
                    if (a.id === "" !== (b.id === "")) {
                        return a.id === "" ? -1 : 1;
                    }
                    return a.tekst.localeCompare(b.tekst, locale, {
                        sensitivity: "variant"
                    });
                }
            case "omvendtAlfabetisk":
                {
                    if (a.id === "" !== (b.id === "")) {
                        return a.id === "" ? -1 : 1;
                    }
                    return -1 * a.tekst.localeCompare(b.tekst, locale, {
                        sensitivity: "variant"
                    });
                }
            case "numerisk":
                {
                    return a - b;
                }
            default:
                return 0;
        }
    };
};
var sorterNedtrekksliste = function(felt, intl, locale) {
    var _felt_opsjon = felt.opsjon, sortering = _felt_opsjon.sortering, _felt_opsjon_verdier = _felt_opsjon.verdier, verdier = _felt_opsjon_verdier === void 0 ? [] : _felt_opsjon_verdier;
    var valgliste = verdier.map(function(valg) {
        return {
            id: valg,
            tekst: formaterTekst(valg, felt, intl, locale)
        };
    });
    return valgliste.sort(sorterListe(sortering, locale));
};
var sorterNedtrekkslisteEtterGruppering = function(felt, intl, locale) {
    var _felt_opsjon = felt.opsjon, sortering = _felt_opsjon.sortering, _felt_opsjon_gruppering = _felt_opsjon.gruppering, gruppering = _felt_opsjon_gruppering === void 0 ? [] : _felt_opsjon_gruppering, _felt_opsjon_verdier = _felt_opsjon.verdier, verdier = _felt_opsjon_verdier === void 0 ? [] : _felt_opsjon_verdier;
    var valgliste = verdier.map(function(valg) {
        if (valg === "") {
            return {
                id: "",
                gruppe: "ingen",
                tekst: formaterTekst(valg.tekniskNavn, felt, intl, locale)
            };
        }
        return {
            id: valg.tekniskNavn,
            gruppe: valg.presentasjonsrekkefoelge,
            tekst: formaterTekst(valg.tekniskNavn, felt, intl, locale)
        };
    });
    return valgliste.sort(function(a, b) {
        if (a.gruppe === b.gruppe) {
            return sorterListe(sortering, locale)(a, b);
        }
        return gruppering.indexOf(a.gruppe) - gruppering.indexOf(b.gruppe);
    }).reduce(function(gruppering, valg) {
        var gruppe = valg.gruppe;
        var _gruppering_gruppe;
        gruppering[gruppe] = (_gruppering_gruppe = gruppering[gruppe]) !== null && _gruppering_gruppe !== void 0 ? _gruppering_gruppe : [];
        gruppering[gruppe].push(valg);
        return gruppering;
    }, {});
};
var medKodetillegg = function(forekomst, feltReferanse, kodeliste, kodetilleggFraKodeliste) {
    var kodetilleggVerdi = (0, _get.default)(kodeliste, [
        forekomst[feltReferanse],
        kodetilleggFraKodeliste
    ], forekomst[feltReferanse]);
    return _object_spread_props(_object_spread({}, forekomst), _define_property({}, feltReferanse, kodetilleggVerdi));
};
var sorterForekomster = function() {
    var forekomster = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], felterForSortering = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], locale = arguments.length > 2 ? arguments[2] : void 0, kodelister = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var compareFelt = function(sorteringsKriterie) {
        return function(a, b) {
            if (typeof sorteringsKriterie === "string") {
                var _a_sorteringsKriterie;
                return (_a_sorteringsKriterie = a[sorteringsKriterie]) === null || _a_sorteringsKriterie === void 0 ? void 0 : _a_sorteringsKriterie.localeCompare(b[sorteringsKriterie], locale);
            } else {
                var feltReferanse = sorteringsKriterie.feltReferanse, typeSortering = sorteringsKriterie.typeSortering, kodeliste = sorteringsKriterie.kodeliste, kodetilleggFraKodeliste = sorteringsKriterie.kodetilleggFraKodeliste;
                var mapA = medKodetillegg(a, feltReferanse, kodelister[kodeliste], kodetilleggFraKodeliste);
                var mapB = medKodetillegg(b, feltReferanse, kodelister[kodeliste], kodetilleggFraKodeliste);
                switch(typeSortering){
                    case "numerisk":
                        {
                            return mapA[feltReferanse] - mapB[feltReferanse];
                        }
                    case "alfabetisk":
                    default:
                        var _mapA_feltReferanse;
                        return (_mapA_feltReferanse = mapA[feltReferanse]) === null || _mapA_feltReferanse === void 0 ? void 0 : _mapA_feltReferanse.localeCompare(mapB[feltReferanse], locale);
                }
            }
        };
    };
    var sorterForEtFelt = function(tilSortering, sorteringsKriterie) {
        return _to_consumable_array(tilSortering).sort(compareFelt(sorteringsKriterie));
    };
    return felterForSortering.reduce(sorterForEtFelt, forekomster);
};
var formaterTekst = function(valg, felt, intl, locale) {
    var _felt_transformer;
    var transformertFelt = _transformering.transformer.transformerFelt(felt, valg, {
        returnerId: true,
        locale: locale
    });
    if (((_felt_transformer = felt.transformer) === null || _felt_transformer === void 0 ? void 0 : _felt_transformer.id) === "ingen" || transformertFelt === "") {
        return transformertFelt;
    }
    if (valg === "") {
        return intl.formatMessage({
            id: transformertFelt,
            defaultMessage: " "
        });
    }
    return intl.formatMessage({
        id: transformertFelt
    });
};
